import Empty from 'constants/empty';
import { SAVE_FOR_LATER_LIST_TYPE, ACTION_TYPES } from 'constants/saveForLater';

const initialState = {
    loading: false,
    error: null,
    lists: Empty.Array,
    listId: null,
    listName: null,
    shareLink: null,
    items: Empty.Array,
    optimisticItems: Empty.Array,
    lastFetchedAt: null
};

const getPrimarySaveForLaterList = lists => {
    if (!Array.isArray(lists)) {
        return null;
    }

    const normalized = lists.find(list => (list.shoppingListType || '').toLowerCase() === SAVE_FOR_LATER_LIST_TYPE) || lists[0];

    if (!normalized) {
        return null;
    }

    return {
        id: normalized.shoppingListId || normalized.id || null,
        name: normalized.shoppingListName || normalized.name || null,
        shareLink: normalized.shareLink || null
    };
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.SET_SAVE_FOR_LATER_LOADING: {
            return { ...state, loading: action.loading };
        }
        case ACTION_TYPES.SET_SAVE_FOR_LATER_ERROR: {
            return { ...state, error: action.error, loading: false };
        }
        case ACTION_TYPES.UPDATE_SAVE_FOR_LATER_LISTS: {
            const lists = Array.isArray(action.lists) ? action.lists : Empty.Array;
            const primaryList = getPrimarySaveForLaterList(lists);

            return {
                ...state,
                lists,
                listId: primaryList?.id || null,
                listName: primaryList?.name || null,
                shareLink: primaryList?.shareLink || null,
                loading: false
            };
        }
        case ACTION_TYPES.UPDATE_SAVE_FOR_LATER_ITEMS: {
            return {
                ...state,
                items: Array.isArray(action.items) ? action.items : Empty.Array,
                lastFetchedAt: Date.now(),
                loading: false
            };
        }
        case ACTION_TYPES.ADD_SAVE_FOR_LATER_ITEM_OPTIMISTIC: {
            const incoming = action.item || Empty.Object;
            const skuId = incoming.skuId || incoming.sku?.skuId;

            if (!skuId) {
                return state;
            }

            const alreadyExists = state.optimisticItems.some(item => (item.skuId || item.sku?.skuId) === skuId);

            if (alreadyExists) {
                return state;
            }

            return {
                ...state,
                optimisticItems: [...state.optimisticItems, incoming],
                items: [incoming, ...state.items.filter(item => (item.skuId || item.sku?.skuId) !== skuId)]
            };
        }
        case ACTION_TYPES.REMOVE_SAVE_FOR_LATER_ITEM_OPTIMISTIC: {
            const skuId = action.skuId;

            if (!skuId) {
                return state;
            }

            return {
                ...state,
                optimisticItems: state.optimisticItems.filter(item => (item.skuId || item.sku?.skuId) !== skuId),
                items: state.items.filter(item => (item.skuId || item.sku?.skuId) !== skuId)
            };
        }
        default: {
            return state;
        }
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

export default reducer;
